import React, { useRef } from "react";
const KS10EmploymentStartDate = (props) => {
  const { setDateData, eday1, eday2, emonth1, emonth2, eyear3, eyear4 } = props;
  
  const day1Ref = useRef(null);
  const day2Ref = useRef(null);
  const month1Ref = useRef(null);
  const month2Ref = useRef(null);
  const year3Ref = useRef(null);
  const year4Ref = useRef(null);
  const onDateChange = (e) => {
    let data = e.target.value;
    if (isNaN(Number(data))) {
      return;
    }
    switch (e.target.name) {
      case "eday1":
        day2Ref.current.focus();
        break;
      case "eday2":
        month1Ref.current.focus();
        break;
      case "emonth1":
        month2Ref.current.focus();
        break;
      case "emonth2":
        year3Ref.current.focus();
        break;
      case "eyear3":
        year4Ref.current.focus();
        break;
    }
    setDateData({ name: e.target.name, value: data });
  };
  return (
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-12 mb-3 section-number-box">
        <div className="mb-3 number" style={{ paddingRight: "15px" }}>
          10.
        </div>
        <div className="details">
          <div className="form-group form-inline">
            <div className="section-label">
              <label className="">Employment start date</label>
            </div>
            <div className="section-form-group">
              <div className="section-form-group-inline pr-1">
              <input maxLength="1" type="text" id="eday1" name="eday1" className="form-control text-center " ref={day1Ref} value={eday1} onChange={onDateChange} />
                <input maxLength="1" type="text" id="eday2" name="eday2" className="form-control text-center mr-1 " ref={day2Ref} value={eday2} onChange={onDateChange} />
                <small className="small-title-label d-flex justify-content-center">Day</small>
              </div>
              <div className="section-form-group-inline pr-1">
              <input maxLength="1" type="text" id="emonth1" name="emonth1" className="form-control text-center" ref={month1Ref} value={emonth1} onChange={onDateChange} />
                <input maxLength="1" type="text" id="emonth2" name="emonth2" className="form-control text-center mr-1" ref={month2Ref} value={emonth2} onChange={onDateChange} />

                <small className="small-title-label d-flex justify-content-center">Month </small>
              </div>
              <div className="section-form-group-inline pr-3">
                <input maxLength="1" type="text" id="eyear1" name="eyear1" className="form-control text-center" value="2" disabled />
                <input maxLength="1" type="text" id="eyear2" name="eyear2" className="form-control text-center" value="0" disabled />
                <input maxLength="1" type="text" id="eyear3" name="eyear3" className="form-control text-center" ref={year3Ref} value={eyear3} onChange={onDateChange} required={true} />
                <input maxLength="1" type="text" id="eyear4" name="eyear4" className="form-control text-center" ref={year4Ref} value={eyear4} onChange={onDateChange} required={true} />
                <small className="small-title-label d-flex justify-content-center">Year</small>
              </div>
              <small className="label-line-height top-space">Give this form to your employer or send it to Inland Revenue.</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KS10EmploymentStartDate;
